"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingProvider = void 0;
var AccountingProvider;
(function (AccountingProvider) {
    AccountingProvider["NETSUITE"] = "NETSUITE";
    AccountingProvider["QUICKBOOKS"] = "QUICKBOOKS";
    AccountingProvider["SELF_REPORTED"] = "SELF_REPORTED";
})(AccountingProvider || (exports.AccountingProvider = AccountingProvider = {}));
